var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-normal',{staticClass:"mailList"},[_c('tree-list',{attrs:{"mailList":_vm.mailList}}),_c('Content',{attrs:{"mailList":_vm.mailList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }